import styled from 'styled-components';

export const Container = styled.div`
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .custom-textfield {
        border-bottom: 1px solid var(--border-hairline); /* Solid black border */
        padding-bottom: 6px; /* Space below the text */
      }
      
      /* Override Material-UI's default underline for focused state */
      .custom-textfield::before, .custom-textfield::after {
        display: none;
      }
      
      /* Style the input text */
      .custom-textfield input {
        font-family: var(--font-body); /* The font from your image */
      }

      .no-spinners {
        -moz-appearance: textfield;
      }
      
      .no-spinners::-webkit-outer-spin-button,
      .no-spinners::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .erro-intervalo {
      border: 2px solid red;
    }

`

